import responseStatusText from "../../../resources/response_statuses.json";
import WebGatewayApi from "./web_gateway_api";
import { CustomError } from "avvir";

const checkFetchStatus = <R extends string | object>(response: Response, displayErrorMessage: boolean = true): Promise<R | never> => {
  const requestPath = response.url.split(WebGatewayApi.baseUrl).join("..."); // split and join to replace text
  if (response.headers.has("Warning")) {
    console.warn(`Warning present in response: ${response.headers.get("Warning")}
from: \`${requestPath}\``);
  }
  if (response.ok) {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json().then(body => {
        return body;
      }) as Promise<R>;
    } else {
      return response.text().then(text => {
        if (text) {
          console.warn(`API returned non-json body from: \`${requestPath}\``);
        }
        return text;
      }) as Promise<R>;
    }
  } else {
    return response.json().then((errorBody) => {
      let message = errorBody.errorDetails || errorBody.message;
      let statusMessage = responseStatusText[response.status];
      let verboseMessage = `${response.status} ${statusMessage}: '${message}' at \`${requestPath}\``;
      const error = new CustomError(
        message,
        verboseMessage,
        response,
        errorBody,
        displayErrorMessage
      );
      console.error(error);
      throw error;
    });
  }
};

/** @deprecated Use equivalent from "avvir" instead */
export default checkFetchStatus;
